module.exports = __webpack_public_path__ + "img/bg2.6f170b84.jpg";